import type {
    SpreadsheetData,
    SpreadsheetRowData,
} from "@components/spreadsheet/types";
import { currencyFormatter } from "@common/helpers/currency";

export interface SpreadsheetLine {
    name: string;
    owner: string;
    category: string;
    amount: number;
}

export const LINE_ITEMS: SpreadsheetLine[] = [
    {
        name: "Northstar Studio",
        owner: "Maya",
        category: "Design",
        amount: 4280,
    },
    {
        name: "Harbor Goods",
        owner: "Noah",
        category: "Retail",
        amount: 1975,
    },
    {
        name: "Juniper Labs",
        owner: "Priya",
        category: "Research",
        amount: 6320,
    },
    {
        name: "Summit Works",
        owner: "Leo",
        category: "Services",
        amount: 3540,
    },
    {
        name: "Cedar House",
        owner: "Ava",
        category: "Hospitality",
        amount: 2860,
    },
    {
        name: "Atlas Supply",
        owner: "Eli",
        category: "Wholesale",
        amount: 5180,
    },
];

export const cloneLineItems = (): SpreadsheetData =>
    LINE_ITEMS.map((line) => ({ ...line }));

export const NESTED_LINES: SpreadsheetRowData[] = [
    {
        _id: "operations",
        name: "Operations",
        owner: "",
        children: [
            {
                _id: "month-end",
                name: "Month end",
                owner: "Maya",
                children: [
                    {
                        _id: "reconcile-bank",
                        name: "Reconcile bank",
                        owner: "Noah",
                    },
                    {
                        _id: "review-accruals",
                        name: "Review accruals",
                        owner: "Priya",
                    },
                ],
            },
        ],
    },
    {
        _id: "reporting",
        name: "Reporting",
        owner: "",
        children: [
            {
                _id: "publish-statements",
                name: "Publish statements",
                owner: "Leo",
            },
            {
                _id: "archive-package",
                name: "Archive package",
                owner: "Ava",
            },
        ],
    },
];

const cloneNestedRow = (row: SpreadsheetRowData): SpreadsheetRowData => ({
    ...row,
    children: row.children?.map(cloneNestedRow),
});

export const cloneNestedLines = (): SpreadsheetRowData[] =>
    NESTED_LINES.map(cloneNestedRow);

export const sumAmount = (rows: SpreadsheetData): number =>
    rows.reduce((sum, row) => {
        const amount = row.amount;
        return typeof amount === "number" ? sum + amount : sum;
    }, 0);

export const formatSumAmount = (rows: SpreadsheetData): string =>
    currencyFormatter.format(sumAmount(rows));
